import { CloseOutlined } from "@ant-design/icons";
import { Button, Divider, Drawer } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GetNotifcationsApi from "../api/notifications/GetNotificationsApi";
import MarkAllAsReadApi from "../api/notifications/MarkAllAsReadApi";
import OpenNotificationApi from "../api/notifications/OpenNotificationApi";
import { SimpleLoader } from "./sub/Loaders";

function Notifications(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const positionState = useSelector((state) => state.positionState.value);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (props.visible) {
      loadMoreData(page);
    }
  }, [props.visible]);

  function handleClose() {
    props.onClose();
    setData([]);
    setPage(1);
  }

  async function loadMoreData(page) {
    setLoading(true);
    const apiResponse = await GetNotifcationsApi(
      page,
      10,
      "",
      positionState.id
    );

    if (apiResponse.success) {
      setData([...data, ...apiResponse.data?.notifications]);
      setLoading(false);
      setTotalCount(apiResponse.data?.totalCount);
    }
  }

  async function openNotification(id) {
    const apiResponse = await OpenNotificationApi(id);
    if (apiResponse.success) {
      handleClose();
      props.handleNotificationCount();
    }
  }
  async function markAllAsRead() {
    const apiResponse = await MarkAllAsReadApi(positionState?.id);
    if (apiResponse.success) {
      handleClose();
      props.handleNotificationCount();
    }
  }

  return (
    <Drawer closable={false} placement="right" visible={props.visible}>
      <div className="flex justify-between items-center">
        <div className="text-lg pri-font">Notifications</div>
        <CloseOutlined onClick={() => handleClose()} />
      </div>
      <Divider />
      <div className="flex justify-end ">
        <div
          className="cursor-pointer -mt-4 mb-2 text-gray-500 hover:text-black"
          onClick={() => markAllAsRead()}
        >
          Mark all as read
        </div>
      </div>

      <>
        {data.map((item) => (
          <Link
            to={item.notification?.url}
            className={
              "border p-2 mb-2 rounded-sm block " +
              (item.status === "UnRead" ? "bg-gray-100" : "bg-white")
            }
            onClick={() => {
              handleClose();
              openNotification(item.id);
            }}
          >
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <div>{moment(item?.createdOn).format("DD.MM.YYYY")}</div>
              <div> {moment(item?.createdOn).format("HH:mm:ss a")}</div>
            </div>
            <div className="text-black mt-1">{item?.notification?.message}</div>
          </Link>
        ))}
        {loading ? (
          <SimpleLoader />
        ) : totalCount > data.length ? (
          <div className="flex items-center justify-center">
            <Button
              onClick={() => {
                loadMoreData(page + 1);
                setPage(page + 1);
              }}
            >
              Load more
            </Button>
          </div>
        ) : (
          <div className="text-center text-gray-500">
            It is all, nothing more.
          </div>
        )}
      </>
    </Drawer>
  );
}

export default Notifications;
